// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AwsIamUsersIcon = createSvgIcon(
  <svg width={40} height={40} fill="none" viewBox="0 0 40 40">
    <path fill="url(#aws-iam-users_svga)" d="M40 0H0v40h40z" />
    <svg width={28} height={29} x={6} y={5.5} viewBox="0 0 28 29">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M26.71 25.3q-.3 0-.66.04l-.17.01a9 9 0 0 1-2.66 0l-.33-.09q-.4-.13-.89-.34a8 8 0 0 0-3.28-.82l-.03-1.28c1.56-.04 2.86.52 3.8.92q.44.19.75.3l.31.08.31.04-.03-.13a6.64 6.64 0 0 0-6.3-4.88 7 7 0 0 0-3.52.82 6.2 6.2 0 0 0-2.59 4.97 5 5 0 0 0 2.22.7c1.7-.72 4.18-.87 5.56-.71 1.06.11 2.2.66 3.12 1.1.5.23 1.02.48 1.28.52.42.07 1.34.01 2.16-.05h.09l.83-.05zm-15.56 1.34q.3-.05.59-.13-.79-.3-1.4-.77l-.94.4c-.28.1-.64.25-.9.38.43.16 1.2.26 2.23.16zm7.8-9.32a7.6 7.6 0 0 0-3.65.8q1.11-.28 2.28-.24a7.9 7.9 0 0 1 7.48 5.85l.1.4.82-.06.26-.02a7.6 7.6 0 0 0-7.3-6.73M28 25l-.06 1.8c-.02.5-.42.9-.93.92l-.32.01-.75.05h-.1c-.97.07-1.89.14-2.46.04a7 7 0 0 1-1.6-.64 10 10 0 0 0-2.72-.98c-1.49-.16-4.3.1-5.5.92-.64.44-1.73.77-2.72.84l-.15.01-.24.02h-.09l-.43.01c-.9 0-2.1-.13-2.72-.8a1 1 0 0 1-.26-.85c.15-.66.92-.96 1.98-1.39q.45-.17.89-.37a8.84 8.84 0 0 1 9.17-8.53 8.9 8.9 0 0 1 8.53 8.08q.1.05.19.14.3.3.29.72M11.46 13.37h1.91v-1.9h-1.9zm3.19-2.54V14c0 .35-.29.64-.64.64h-3.18a.64.64 0 0 1-.64-.64v-3.18c0-.36.28-.64.64-.64H14c.35 0 .64.28.64.64m-9.56 2.54h1.92v-1.9H5.09zm3.19-2.54V14c0 .35-.29.64-.64.64H4.46a.64.64 0 0 1-.64-.64v-3.18c0-.36.29-.64.64-.64h3.18c.35 0 .64.28.64.64M11.46 7h1.91V5.09h-1.9zm3.19.63c0 .35-.29.64-.64.64h-3.18a.64.64 0 0 1-.64-.64V4.46c0-.35.28-.64.64-.64H14c.35 0 .64.29.64.64zm-9.56-.63h1.92V5.09H5.09zm3.19.63c0 .35-.29.64-.64.64H4.46a.64.64 0 0 1-.64-.64V4.46c0-.35.29-.64.64-.64h3.18c.35 0 .64.29.64.64zm3.18 10.83h-5.1a.64.64 0 0 0-.63.63v8.92H1.5c-.82 0-1.49-.58-1.49-1.3V1.3C0 .58.67 0 1.49 0h15.5c.81 0 1.48.58 1.48 1.3v13.35h-1.28V1.3c0 .03-.08-.03-.2-.03H1.48c-.13 0-.21.06-.23.08l.01 25.37c0-.03.08.03.22.03h2.97V19.1c0-1.05.85-1.9 1.9-1.9h5.1z"
        clipRule="evenodd"
      />
    </svg>
    <defs>
      <linearGradient
        id="aws-iam-users_svga"
        x1={0}
        x2={40.99}
        y1={0}
        y2={38.96}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
    </defs>
  </svg>,
  "AwsIamUsers",
);
export default AwsIamUsersIcon;
